import { queryOptions } from '@tanstack/react-query';
import { mutationOptions } from '../../common/utils';
import { deviceAPIClient } from '../deviceAPIClient';
import { DEVICE_QUERY_KEYS } from './keys';
import type {
  GetGeoLocationRequest,
  SearchAddressRequest,
  GetAddressDetailsRequest,
  GetPostalCodeRequest,
} from './types';

export const DEVICE_QUERIES = {
  getGeoLocation: (params: GetGeoLocationRequest) =>
    queryOptions({
      queryKey: DEVICE_QUERY_KEYS.geoLocation(params),
      queryFn: async () => deviceAPIClient.getGeoLocation(params),
      enabled: Boolean(params?.ip),
    }),
  searchAddress: (params: SearchAddressRequest) =>
    queryOptions({
      queryKey: DEVICE_QUERY_KEYS.searchStreetAddress(params),
      queryFn: async () => deviceAPIClient.getSearchAddress(params),
      enabled: Boolean(params?.input),
    }),
  getAddressDetails: (params: GetAddressDetailsRequest) =>
    queryOptions({
      queryKey: DEVICE_QUERY_KEYS.getAddressDetails(params),
      queryFn: async () => deviceAPIClient.getAddressDetails(params),
      enabled: Boolean(params?.placeId),
    }),
  getPostalCode: (params: GetPostalCodeRequest) =>
    queryOptions({
      queryKey: DEVICE_QUERY_KEYS.getPostalCode(params),
      queryFn: async () => deviceAPIClient.getPostalCode(params),
      enabled: Boolean(params?.postalCode),
    }),
};

export const DEVICE_MUTATIONS = {
  getGeoLocation: () =>
    mutationOptions({
      mutationFn: (params: GetGeoLocationRequest) => deviceAPIClient.getGeoLocation(params),
    }),
  searchAddress: () =>
    mutationOptions({
      mutationFn: (params: SearchAddressRequest) => deviceAPIClient.getSearchAddress(params),
    }),
  getAddressDetails: () =>
    mutationOptions({
      mutationFn: (params: GetAddressDetailsRequest) => deviceAPIClient.getAddressDetails(params),
    }),
  getPostalCode: () =>
    mutationOptions({
      mutationFn: (params: GetPostalCodeRequest) => deviceAPIClient.getPostalCode(params),
    }),
};
